import { type MutationSignal } from './mutationSignal';

type MutationResult = Record<string, unknown> | null | undefined;

export function extractSignalFields(
  kind: MutationSignal['kind'],
  result: MutationResult,
): MutationSignal | undefined {
  if (!result || typeof result !== 'object') return undefined;

  const name = result.name;
  if (typeof name !== 'string') return undefined;

  return {
    kind,
    resourceName: name,
    displayName:
      typeof result.displayName === 'string' ? result.displayName : undefined,
  };
}
